<template>
  <div class="address-book-view scroll-contents">
    <header>
      <h1>連絡先</h1>
      <button class="add-category-btn" :class="{disable: !currentUser || currentUser.state !== 2}" @click="newCategory">グループ追加 ＋</button>
    </header>
    <div class="address-book-body">
      <div class="account-notify-message" v-if="!currentUser || currentUser.state !== 2">
        利用可能なユーザーがいません。
      </div>
      <div 
        class="category-block"
        v-for="category in addressBook"
        :key="'adrctg' + category.id"
        >
        <div class="category-title">
          <div class="category-name">{{ category.name }}</div>
          <div class="controll-buttons">
            <img src="/images/import_nb_icon.svg" class="import-nb-icon" v-if="currentUser && currentUser.nb_id" @click="importFromNarrativebook(category)" />
            <img src="/images/qr_icon.svg" class="show-qr-icon" @click="showExchangeQR(category)" />
            <img src="/images/camera_icon.svg" class="read-qr-icon" @click="showExchangeQRReader(category)" />
            <img src="/images/edit_icon.svg" class="edit-category-icon" @click="editCategory(category)" />
            <img src="/images/trash_icon.svg" class="delete-category-icon" @click="deleteCategory(category)" />
          </div>
        </div>
        <div class="entry-block"
          v-for="entry in category.address_entries"
          :key="'adrent' + entry.id"
          @click="showEntryDetail(entry)">
          <div class="entry-info-block">
            <div class="entry-icon"><user-portrate :target="entry" :displaySize="'middle'"/></div>
            <div class="entry-name">
              <div class="name">
                {{ entry.name }}
                <img src="/images/user_favourite_on.svg" class="favo-icon" v-show="entry.favourite"/>
              </div>
              <div class="description" v-html="entryDescriptionHTML(entry)"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <address-exchange-display-modal
      :modalDisplay="showQRModalDisplay"
      :addressCategory="targetCategory"
      v-on:addressExchangeFinishedEvent="displayAddressExchanged"
      v-on:closeModalEvent="closeExchangeQR"
      />
    <!-- <address-exchange-read-modal
      :modalDisplay="readQRModalDisplay"
      :addressCategory="targetCategory"
      v-on:addressExchangeFinishedEvent="readAddressExchanged"
      v-on:addressExchangeFailedEvent="readAddressExchangeFailed"
      v-on:closeModalEvent="closeExchangeQRReader"
      /> -->
    <import-narrativebook-modal
      :category="targetCategory"
      :modalDisplay="narrativebookImportModalDisplay"
      v-on:cancelEvent="cancelImportSelect"
      v-on:addressImportFinishEvent="importFromNarrativebookFinised"
      v-on:addressImportFetchFailedEvent="importFromNarrativebookFetchFailed"
      v-on:addressImportFailedEvent="importFromNarrativebookFailed"
      />
    <address-entry-detail-modal
      :addressEntryID="detailTargetEntryID"
      :modalDisplay="entryDetailDisplay"
      :returnLinkName="'連絡先'"
      v-on:closeModalEvent="closeEntryDetailModal"
      v-on:prepareCallEvent="prepareCall"
      />
    <select-address-category-modal
      :modalDisplay="categorySelectModalDisplay"
      :currentCategory="targetCategory"
      v-on:categorySelectedEvent="categorySelected"
      v-on:closeModalEvent="closeSelectCategory"
      />
    <address-category-form-modal
      :modalDisplay="categoryFormModalDisplay"
      :category="targetCategory"
      v-on:cancelEvent="addressCategoryFormClose"
      v-on:createFinishedEvent="addressCategoryCreated"
      v-on:createFailedEvent="addressCategoryCreateFailed"
      v-on:updateFinishedEvent="addressCategoryUpdated"
      v-on:updateFailedEvent="addressCategoryUpdateFailed"
      />
    <confirm-dialog
      :showDialog="confirmDialogVisible"
      :title="confirmDialogTitle"
      :message="confirmDialogMessage"
      :dialogType="confirmDialogType"
      v-on:negativeResultEvent="confirmFinishNegative"
      v-on:positiveResultEvent="confirmFinishPositive"
      />
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

import UserPortrate from '@/components/appView/common/UserPortrate.vue'
import AddressExchangeDisplayModal from '@/components/appView/addressBook/AddressExchangeDisplayModal.vue'
// import AddressExchangeReadModal from '@/components/appView/addressBook/AddressExchangeReadModal.vue'
import ImportNarrativebookModal from '@/components/appView/addressBook/ImportNarrativebookModal.vue'
import AddressCategoryFormModal from '@/components/appView/addressBook/AddressCategoryFormModal.vue'
import AddressEntryDetailModal from '@/components/appView/addressBook/AddressEntryDetailModal.vue'
import SelectAddressCategoryModal from '@/components/appView/common/SelectAddressCategoryModal.vue'
import ConfirmDialog from '@/components/common/ConfirmDialog.vue'

import ConfirmDialogControll from '@/mixin/ConfirmDialogControll'

import * as DIALOG_TYPE from '@/assets/constants/dialogType.js'

export default {
  mixins: [ ConfirmDialogControll ],
  name: 'AddressBookView',

  components: {
    // TODO: categoryForm
    UserPortrate,
    AddressExchangeDisplayModal,
    // AddressExchangeReadModal,
    ImportNarrativebookModal,
    AddressCategoryFormModal,
    AddressEntryDetailModal,
    SelectAddressCategoryModal,
    ConfirmDialog,
  },

  props: {
    addressBookUpdatedFlag: Boolean,
  },

  data() {
    return {
      categoryFormModalDisplay: false,
      entryDetailModalDisplay: false,
      categorySelectModalDisplay: false,
      narrativebookImportModalDisplay: false,
      showQRModalDisplay: false,
      readQRModalDisplay: false,
      targetCategory: null,
      targetEntry: null,
      entryClone: false,
      entryDetailDisplay: false,
      detailTargetEntryID: 0,
    }
  },

  watch: {
    currentUser: { handler: 'loadAddressBook', immediate: true },
    addressBookUpdatedFlag: { handler: 'addressUpdated', immediate: true }
  },

  computed: {
    ...mapState({
      currentUser: state => state.user.currentUser,
      addressBook: state => state.addressBook.addressCategories,
      narrativebookLists: state => state.addressBook.narrativebookAddresses,
    }),

    ...mapGetters({
      categorySelectable: 'addressBook/categorySelectable'
    }),

    categorySelectionAvailable () {
      if (this.addressBook.length > 1) {
        return true
      }
      return false
    }
  },

  methods: {
    ...mapActions({
      fetchAddressBook: 'addressBook/fetch',
      createCategory: 'addressBook/create',
      updateCategory: 'addressBook/update',
      destroyCategory: 'addressBook/destroy',
      createEntry: 'addressBook/createEntry',
      updateEntry: 'addressBook/updateEntry',
      fetchListFromNarrativebook: 'addressBook/fetchListFromNarrativebook',
    }),

    loadAddressBook () {
      console.log('in AddressBook, call loadAddressBook,,,')
      try {
        this.fetchAddressBook()
      } catch (error) {
        console.error(error)
        this.showNotifyDialog('インターネット未接続', 'インターネットに接続してないため利用できません。')
      }
    },

    async addressUpdated () {
      if (this.addressBookUpdatedFlag) {
        await this.loadAddressBook()
        this.$emit('addressReloadedEvent')
      }
    },

    entryDescriptionHTML (entry) {
      if (entry.description) {
        return entry.description.replace(/\n/gi, '<br />')
      }
      return ''
    },

    newCategory () {
      // show edit modal
      this.targetCategory = null
      this.categoryFormModalDisplay = true
    },

    editCategory (category) {
      // show edit modal
      this.targetCategory = category
      this.categoryFormModalDisplay = true
    },

    addressCategoryFormClose () {
      this.categoryFormModalDisplay = false
      this.targetCategory = null
    },

    addressCategoryCreated () {
      this.showMessageDialog('連絡先グループの追加', '連絡先グループを追加しました')
      this.categoryFormModalDisplay = false
      this.targetCategory = null
      this.fetchAddressBook()
    },

    addressCategoryCreateFailed () {
      this.showNotifyDialog('連絡先グループの追加失敗', '連絡先グループの追加に失敗しました')
      this.categoryFormModalDisplay = false
      this.targetCategory = null
      this.fetchAddressBook()
    },

    addressCategoryUpdated () {
      this.showMessageDialog('連絡先グループの更新', '連絡先グループを更新しました')
      this.categoryFormModalDisplay = false
      this.targetCategory = null
      this.fetchAddressBook()
    },

    addressCategoryUpdateFailed () {
      this.showNotifyDialog('連絡先グループの更新失敗', '連絡先グループの更新に失敗しました')
      this.categoryFormModalDisplay = false
      this.targetCategory = null
      this.fetchAddressBook()
    },

    deleteCategory (category) {
      this.showConfirmDialog(
          "連絡先グループの削除", 
          '連絡先グループ[' + category.name + ']を削除します。関連して、このグループに含まれる連絡先はすべて削除されます。\nこの操作は戻せません。\n削除してよろしいですか？',
          DIALOG_TYPE.EXECUTE, 
          () => { this.executeDeleteCategory(category) }
        )
    },

    executeDeleteCategory (category) {
      this.destroyCategory({ targetID: category.id }).then(res => {
        console.log(res)
        this.showMessageDialog('連絡先グループの削除', '連絡先グループを削除しました')
      }).catch(error => {
        console.error(error)
        this.showNotifyDialog('連絡先グループの削除失敗', '連絡先グループの削除に失敗しました')
      })
    },

    entryUpdate (entry, attributes) {
      let formData = new FormData()
      formData.append('id', entry.id)
      formData.append('address_category_id', entry.address_category_id)
      formData.append('memo', attributes.memo)
      formData.append('favourite', attributes.favourite)
      this.updateEntry(formData).then(() => {
        this.fetchAddressBook()
      })
    },

    selectMoveCategory (entry, category, clone) {
      // show modal
      this.targetCategory = category
      this.targetEntry = entry
      this.entryClone = clone
      this.categorySelectModalDisplay = true
    },

    categorySelected (category) {
      if (this.entryClone) {
        this.copyEntry(this.targetEntry, category)
      } else {
        this.moveCategory(this.targetEntry, category)
      }
      this.categorySelectModalDisplay = false
    },

    closeSelectCategory () {
      this.categorySelectModalDisplay = false
      this.targetEntry = null
    },

    moveCategory (entry, category) {
      let formData = new FormData()
      formData.append('id', entry.id)
      formData.append('address_category_id', category.id)
      this.updateEntry(formData).then(() => {
        // notify
        this.showMessageDialog("連絡先のグループ移動", '連絡先[' + entry.name + ']をグループ[' + category.name + ']に移動しました。')
        this.targetCategory = null
        this.targetEntry = null
      })
    },

    copyEntry (entry, category) {
      let formData = new FormData()
      formData.append('narrative_phone_id', entry.narrative_phone_id)
      formData.append('address_category_id', category.id)
      this.createEntry(formData).then(() => {
        this.showMessageDialog("連絡先のコピー", '連絡先[' + entry.name + ']をグループ[' + category.name + ']にコピーしました。')
        this.targetCategory = null
        this.targetEntry = null
      })
    },

    importFromNarrativebook (category) {
      // show modal
      this.fetchListFromNarrativebook()
      this.targetCategory = category
      this.narrativebookImportModalDisplay = true
    },

    importFromNarrativebookFetchFailed () {
      this.narrativebookImportModalDisplay = false
      this.targetCategory = null
      this.showNotifyDialog('連絡先のインポート失敗', 'ナラティブブックとの接続に失敗しました。')
    },

    cancelImportSelect () {
      this.narrativebookImportModalDisplay = false
      this.targetCategory = null
    },

    // MEMO: モーダル側でインポート処理までしてしまうので結果の表示のみを行う
    importFromNarrativebookFinised (message) {
      this.narrativebookImportModalDisplay = false
      this.targetCategory = null
      // show daialog
      this.showMessageDialog('連絡先のインポート', message)
      this.fetchAddressBook()
    },

    importFromNarrativebookFailed (message) {
      // 失敗を表示しておく
      this.narrativebookImportModalDisplay = false
      this.targetCategory = null
      this.showNotifyDialog('連絡先のインポート', message)
      this.fetchAddressBook()
    },

    showExchangeQR (category) {
      // show modal
      this.targetCategory = category
      this.showQRModalDisplay = true
    },

    closeExchangeQR () {
      this.showQRModalDisplay = false
      this.targetCategory = null
    },
    
    displayAddressExchanged (message) {
      // show notify
      this.showMessageDialog('連絡先の交換', message)
      this.closeExchangeQR()
      this.loadAddressBook()
    },

    showExchangeQRReader (category) {
      // show modal
      // this.targetCategory = category
      // this.readQRModalDisplay = true
      // イベントをTopViewに伝搬させる
      this.$emit('readQRRequestEvent', category)
    },

    // TopViewで処理
    // closeExchangeQRReader () {
    //   this.readQRModalDisplay = false
    //   this.targetCategory = null
    // },

    // readAddressExchanged (message) {
    //   // show notify
    //   this.showMessageDialog("連絡先の交換", message)
    //   this.closeExchangeQRReader()
    //   this.loadAddressBook()
    // },

    // readAddressExchangeFailed (message) {
    //   this.showNotifyDialog("連絡先の交換に失敗しました", message)
    //   this.closeExchangeQRReader()
    //   this.loadAddressBook()
    // },

    showEntryDetail (entry) {
      this.detailTargetEntryID = entry.id
      this.entryDetailDisplay = true
    },

    closeEntryDetailModal () {
      this.entryDetailDisplay = false
      this.detailTargetEntryID = 0
    },

    prepareCall (account_name, attendees) {
      this.$emit('prepareCallEvent', account_name, attendees)
    },
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/global.scss';
@import '@/assets/css/mediaQuery.scss';
@import '@/assets/css/colorTable.scss';

.address-book-view {
  height: 100%;
  header {
    height: calc(65px - 20px - 10px);
  }
  .add-category-btn {
    padding: 0 17px;
    background-color: $normal-btn-color;
    color: $normal-btn-text-color;
    font-weight: bold;
    border: 1px solid $normal-btn-color;
    height: 34px;
    border-radius: 17px;
    &.disable {
      background-color: $disable-btn-color;
      border-color: $disable-btn-color;
    }
  }
  .account-notify-message {
    padding: 50px 0;
    color: $danger-color;
    text-align: center;
    font-weight: bold;
    font-size: 1.2rem;
  }
  .address-book-body {
    height: calc(100% - 65px);
    overflow: auto;
  }
  .category-block {
    .category-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 40px;
      background-color: #ddd;
      .category-name {
        padding-left: 40px;
        font-size: 16pt;
      }
      .controll-buttons {
        display: flex;
        align-items: center;
        img {
          padding-right: 10px;
          margin: 3px 5px;
          height: 30px;
          &.import-nb-icon {
            height: 30px;
          }
          &.show-qr-icon { height: 30px; }
          &.read-qr-icon { height: 20px; }
          &.edit-category-icon { height: 30px; }

        }
      }
    }
    .entry-block {
      display: flex;
      border-bottom: 1px solid #ddd;
      .entry-info-block {
        padding: 10px;
        display: flex;
        .entry-icon {
          width: 50px;
          height: 50px;
        }
        .entry-name {
          padding-left: 10px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          .name {
            font-size: 24px;
            img.favo-icon {
              margin-left: 5px;
              width: 20px;
            }
          }
          .description {
            font-size: 10pt;
          }
        }
      }
    }
  }
}
</style>